import UserService from '@/services/UserService';
import { getError } from '@/utils/helpers';
import * as API from '@/services/API';

function setPaginatedUsers(commit, response) {
  commit('SET_USERS', response.data.data);
  commit('SET_META', response.data.meta);
  commit('SET_LINKS', response.data.links);
  commit('SET_LOADING', false);
}
export default {
  getUsers({ commit }, page) {
    commit('SET_LOADING', true);
    UserService.getUsers(page)
      .then((response) => {
        setPaginatedUsers(commit, response);
      })
      .catch((error) => {
        commit('SET_LOADING', false);
        commit('SET_ERROR', getError(error));
      });
  },
  paginateUsers({ commit }, link) {
    commit('SET_LOADING', true);
    UserService.paginateUsers(link)
      .then((response) => {
        setPaginatedUsers(commit, response);
      })
      .catch((error) => {
        commit('SET_LOADING', false);
        commit('SET_ERROR', getError(error));
      });
  },

  getTasksComingUp({ commit }, params) {
    API.apiClient
      .get('/teams/tasks', { params: params })
      .then((response) => {
        commit('SET_TASKS_COMING_UP', response.data);
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
  async getUserProfile({ commit, rootGetters }, params) {
    return await API.apiClient
      .get('/teams/' + rootGetters['auth/authUser'].current_team_id + '/members/' + params)
      .then((response) => {
        commit('SET_PROFILE', response.data);
        return response.data;
      });
    // .catch((error) => {
    //   commit('SET_ERROR', error, { root: true });
    // });
  },

  async update({ commit, rootGetters }, payload) {
    await API.apiClient
      .post('../user/profile-information', payload)
      .then((response) => {
        commit('SET_SUCCESS', 'Profile updated successfully', { root: true });
      })
      .catch((error) => {
        console.log(error);
        commit('SET_ERROR', error, { root: true });
      });
  },

  async updatePassword({ commit, rootGetters }, payload) {
    await API.apiClient
      .post('../user/password', payload)
      .then((response) => {
        commit('SET_SUCCESS', 'Password updated successfully', { root: true });
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
};
